import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import CheckboxGroup from '../../../../../../../features/components/Form/CheckboxGroup'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import Spoiler from '../../../../../../../components/Spoiler'

import { getPlacementsList } from '../../../../../placements/helpers'

import { facebookRightUploadAdCampaignSelector } from '../../../../../../../modules/selectors/rights'

import {
  ALL_PLACEMENTS,
  FACEBOOK_AND_INSTAGRAM,
  FACEBOOK_AND_INSTAGRAM_FEEDS,
  FACEBOOK_FEEDS,
  FACEBOOK_ONLY,
  INSTAGRAM_FEEDS,
  INSTAGRAM_ONLY,
  PLACEMENTS_OPTION,
  RECOMMENDED_PLACEMENTS,
  STORIES_AND_REELS
} from '../../fields'
import { PLACEMENT_POSITIONS } from '../../../../../../Multiplatform/LineItemForms/fields'

const PlacementsStep = ({ formik, handleStepChange, isLastStep }) => {
  const { t } = useTranslation()

  const { values, setValues, setFieldValue } = formik

  const campaign = useSelector(facebookRightUploadAdCampaignSelector)
  const { objective: campaignObjective } = campaign

  const placementsList = getPlacementsList(campaignObjective)

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  return (
    <>
      <Step
        stepTitle="Which placements should the ads be shown on?"
        handleContinue={isLastStep ? null : handleContinue}
      >
        <RadioBlock
          setFieldValue={setFieldValue}
          id={RECOMMENDED_PLACEMENTS}
          name={PLACEMENTS_OPTION}
          label={t('Recommended Placements')}
          value={RECOMMENDED_PLACEMENTS}
          selectedValue={values[PLACEMENTS_OPTION]}
        >
          <p>{t('Facebook and Instagram Feeds, Stories, Reels, Explore, Profile Feeds and In-Stream Video.')}</p>
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id={ALL_PLACEMENTS}
          name={PLACEMENTS_OPTION}
          label={t('All placements')}
          value={ALL_PLACEMENTS}
          selectedValue={values[PLACEMENTS_OPTION]}
        />
        <Spoiler title="Other placement options">
          <RadioBlock
            setFieldValue={setFieldValue}
            id={FACEBOOK_AND_INSTAGRAM}
            name={PLACEMENTS_OPTION}
            label={t('Facebook and Instagram only')}
            value={FACEBOOK_AND_INSTAGRAM}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={FACEBOOK_ONLY}
            name={PLACEMENTS_OPTION}
            label={t('Facebook only')}
            value={FACEBOOK_ONLY}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={INSTAGRAM_ONLY}
            name={PLACEMENTS_OPTION}
            label={t('Instagram only')}
            value={INSTAGRAM_ONLY}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={FACEBOOK_AND_INSTAGRAM_FEEDS}
            name={PLACEMENTS_OPTION}
            label={t('Facebook and Instagram Feeds only')}
            value={FACEBOOK_AND_INSTAGRAM_FEEDS}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={FACEBOOK_FEEDS}
            name={PLACEMENTS_OPTION}
            label={t('Facebook Feeds only')}
            value={FACEBOOK_FEEDS}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={INSTAGRAM_FEEDS}
            name={PLACEMENTS_OPTION}
            label={t('Instagram Feeds only')}
            value={INSTAGRAM_FEEDS}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id={STORIES_AND_REELS}
            name={PLACEMENTS_OPTION}
            label={t('Stories and reels only')}
            value={STORIES_AND_REELS}
            selectedValue={values[PLACEMENTS_OPTION]}
          />
          <RadioBlock
            setFieldValue={setFieldValue}
            id="custom"
            name={PLACEMENTS_OPTION}
            label={t('Custom')}
            value="custom"
            selectedValue={values[PLACEMENTS_OPTION]}
          >
            <CheckboxGroup
              title={t('Custom placements')}
              options={placementsList}
              values={values}
              itemPath={PLACEMENT_POSITIONS}
              setFieldValue={setFieldValue}
              setValues={setValues}
              isLarge={false}
              showSelectAllButton={true}
            />
          </RadioBlock>
        </Spoiler>
      </Step>
    </>
  )
}

export default PlacementsStep
